module.exports = __webpack_public_path__ + "media/images/resp_file-eadea836c5681f9abacb5b0de9cbaf9d.png";